import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e2bf167&scoped=true&lang=html&"
import script from "./recommendStoreList.js?vue&type=script&lang=js&"
export * from "./recommendStoreList.js?vue&type=script&lang=js&"
import style0 from "./recommendStoreList.styl?vue&type=style&index=0&id=2e2bf167&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2bf167",
  null
  
)

export default component.exports